/* tslint:disable */
/* eslint-disable */
/**
 * PRTIMES Media User API
 * メディアユーザーマイページ用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetInitialSettingsCompletionResponseAllOfData
 */
export interface GetInitialSettingsCompletionResponseAllOfData {
    /**
     * 初期設定が完了しているか
     * @type {boolean}
     * @memberof GetInitialSettingsCompletionResponseAllOfData
     */
    isCompleted: boolean;
}

export function GetInitialSettingsCompletionResponseAllOfDataFromJSON(json: any): GetInitialSettingsCompletionResponseAllOfData {
    return GetInitialSettingsCompletionResponseAllOfDataFromJSONTyped(json, false);
}

export function GetInitialSettingsCompletionResponseAllOfDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetInitialSettingsCompletionResponseAllOfData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'isCompleted': json['is_completed'],
    };
}

export function GetInitialSettingsCompletionResponseAllOfDataToJSON(value?: GetInitialSettingsCompletionResponseAllOfData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'is_completed': value.isCompleted,
    };
}

